export class Config {

    constructor(
        public institutionId: string) {
    }

    static fromJsonList(array): Config[] {
        return array.map(Config.fromJson);
        // même chose: return array.map(json => Lesson.fromJson(json));
    }

    static fromJson({ institutionId }): Config {

        return new Config(
            institutionId
        )
    }
}


// WEBPACK FOOTER //
// C:/dev/Perso/urmeo/src/app/shared/model/config.ts